/**
 * Toggle content
 */

 var component_toggle_content = function() {

  // setup args
  const parent = document.querySelector('.toggle-content');
  const items = document.querySelectorAll('.toggle-content .wp-block-group');

  // validate
  if (!items) {
    console.log('no toggle-content suplied');
    return;
  }


  /**
   * Init
   */
  function init_component_toggle_content() {

    // move items inside new element
    items.forEach((item) => {

      // create new details and summary elements
      const details = document.createElement('details');
      const summary = document.createElement('summary');

      // place details inside parent element
      parent.appendChild(details);

      // move group-blocks inside details
      details.append(item);

      // get first heading element inside item
      const heading = item.getElementsByClassName('wp-block-heading')[0];

      // move heading inside details
      details.prepend(heading);

      // move summary inside details
      details.prepend(summary);

      // move heading inside summary
      summary.appendChild(heading);

      // if item has class default-open
      if (parent.classList.contains('default-open')) {
        // open the details
        parent.querySelector('details').setAttribute('open', true);
      }
    });

    return;
  }
  init_component_toggle_content();

  // make the call chainable
  return this;
};
